import { Directive, ElementRef, Inject, Input, OnInit } from '@angular/core';
import { THEME_TOKEN, Theme } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import {
  stepperLineStylesSAG,
  stepperLineStylesSHS,
} from './stepper-line.styles';
import { style } from '../../utils/style.utils';

@Directive({
  selector: '[sag-ui-stepper-line]',
})
export class StepperLineDirective implements OnInit {
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';

  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  ngOnInit(): void {
    const inputStyles = componentStylesByTheme(
      this.theme,
      stepperLineStylesSAG,
      stepperLineStylesSHS
    );

    style(this.elementRef, inputStyles({ orientation: this.orientation }));
  }
}
